import React from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { Download as DownloadIcon } from "@mui/icons-material";
import {
  isImageFile,
  isVideoFile,
  isAudioFile,
  isPDFFile,
  isOfficeFile,
  isTextFile,
} from "../utils/fileHelpers";

const ViewTab = ({ file, fileContent, loadingFileContent, onDownload }) => {
  if (!file) {
    return (
      <Box sx={{ textAlign: "center", py: 4 }}>
        <Typography variant="body2" color="text.secondary">
          No file selected
        </Typography>
      </Box>
    );
  }

  const resolvedUrl = file?.isPublic && file?.publicUrl ? file.publicUrl : file?.url;

  if (isImageFile(file)) {
    return (
      <Box
        component="img"
        src={resolvedUrl}
        alt={file.name}
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          backgroundColor: "#ffffff",
        }}
      />
    );
  }

  if (isVideoFile(file)) {
    return (
      <Box
        component="video"
        controls
        src={resolvedUrl}
        sx={{ width: "100%", height: "100%" }}
      />
    );
  }

  if (isAudioFile(file)) {
    return (
      <Box sx={{ textAlign: "center", py: 4 }}>
        <Box
          component="audio"
          controls
          src={resolvedUrl}
          sx={{ width: "100%", maxWidth: "500px" }}
        />
      </Box>
    );
  }

  if (isPDFFile(file)) {
    return (
      <iframe
        src={resolvedUrl}
        title={file.name}
        style={{ width: "100%", height: "100%", border: "none" }}
      />
    );
  }

  if (isOfficeFile(file)) {
    return (
      <iframe
        src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
          resolvedUrl
        )}`}
        title={file.name}
        style={{ width: "100%", height: "100%", border: "none" }}
      />
    );
  }

  if (isTextFile(file)) {
    return (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          overflow: "auto",
          backgroundColor: "#f8f9fa",
          p: 2,
        }}
      >
        {loadingFileContent ? (
          <Box sx={{ textAlign: "center", py: 4 }}>
            <CircularProgress size={24} />
          </Box>
        ) : (
          <Typography
            component="pre"
            sx={{
              fontFamily: "monospace",
              fontSize: "12px",
              color: "#334155",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              margin: 0,
            }}
          >
            {fileContent}
          </Typography>
        )}
      </Box>
    );
  }

  // Default: Preview not available
  return (
    <Box sx={{ textAlign: "center", py: 4 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Preview not available
      </Typography>
      <Button
        variant="contained"
        size="small"
        startIcon={<DownloadIcon />}
        onClick={() => onDownload?.(file)}
        disabled={!file}
      >
        Download
      </Button>
    </Box>
  );
};

export default ViewTab;
